import { create } from "zustand";

/**
 * Чей звук трансляции слышно.
 *
 * Трансляций бывает несколько, и звучать все разом они не должны: три окна
 * одновременно — это не выбор, а каша. Слышно ту, что развёрнута, и звук
 * переезжает вместе с ней.
 *
 * Отдельно от развёрнутой держится закрепление: иногда нужно смотреть одну
 * картинку, а слушать другую — например, следить за графиками, пока говорит
 * чужая игра. Закрепление сильнее развёрнутой и живёт до отмены.
 *
 * Модуль отдельный, потому что стороны разные: выбирает голосовой экран, а
 * вставляет звук в дерево полоса звонка, и она живёт снаружи, вне этого
 * экрана. Связывать их через состояние пришлось бы через всё приложение.
 *
 * Стор zustand, а не свой список подписчиков — по той же причине, что и у
 * громкости: см. `volume.ts`.
 */
interface Sound {
  /** Развёрнутая трансляция: её слышно, пока не закреплена другая. */
  shown: string | null;
  /** Закреплённая вручную. */
  pinned: string | null;
}

export const useSound = create<Sound>()(() => ({ shown: null, pinned: null }));

export function showSound(owner: string | null) {
  if (useSound.getState().shown !== owner) useSound.setState({ shown: owner });
}

/** Закрепить звук за трансляцией. Повторный вызов той же — снять. */
export function pinSound(owner: string | null) {
  useSound.setState((sound) => ({ pinned: sound.pinned === owner ? null : owner }));
}

/**
 * Чей звук трансляции играть.
 *
 * `null` означает «ничей не выбран» — так бывает, пока трансляций нет. Это
 * не то же самое, что «играть все»: беззвучная тишина лучше трёх наложенных
 * друг на друга окон.
 */
export function soundOwner(value: Sound = useSound.getState()): string | null {
  return value.pinned ?? value.shown;
}
